module.exports = __webpack_public_path__ + "assets/img/btn_chip_3.a793c96b.png";